import React, { Component } from 'react';
import Swiper from 'react-id-swiper/lib/custom';
import Search from "../../components/search/search"


export default class Slideshow extends Component {

    render() {
        const params = {
            autoplay: {
                delay: 3500,
                disableOnInteraction: false
            },
            lazy: true,
            loop: true,
            loopFillGroupWithBlank: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        };

        return (
            <div className="slideshow">
                <Swiper {...params}>
                    <div ><div><img className="slideshow-img" src="/assets/images/slideshow/s3.jpg" alt="s1" /></div></div>
                    <div ><div><img className="slideshow-img" src="/assets/images/slideshow/s3.jpg" alt="s21" /></div></div>
                    <div ><div><img className="slideshow-img" src="/assets/images/slideshow/s3.jpg" alt="s1" /></div></div>
                    <div ><div><img className="slideshow-img" src="/assets/images/slideshow/s3.jpg" alt="s2" /></div></div>
                </Swiper>
                <Search cities={this.props.cities} categories={this.props.categories} />

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/containers/home/slideshow.jsx